import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/pruvodce/[url]/BlogPostPageClient.tsx");
